import { PROFILE_DUCK, VALIDATION_STATUS } from '../core/actions'
import { IFSC_FORMAT } from '../core/constants'

const SUCCESS = VALIDATION_STATUS.SUCCESS
const FAILURE = VALIDATION_STATUS.FAILURE

export const validateBankAccountAttributes = (type, value) => async (state, dispatch) => {
  const errorMessage = {}

  if (value === '' || value === undefined || value === null) {
    errorMessage[type] = { status: FAILURE, value: 'Field cannot be empty' }
  } else {
    errorMessage[type] = { status: SUCCESS, value: '' }
  }

  switch (type) {
    case 'reAccountNumber':
      if (state?.updateBank?.accountNumber === value) {
        errorMessage[type] = { status: SUCCESS, value: '' }
      } else {
        errorMessage[type] = { status: FAILURE, value: 'Must match with Account Number' }
      }
      break
    case 'ifsc':
      if (IFSC_FORMAT.test(value)) {
        errorMessage[type] = { status: SUCCESS, value: '' }
      } else {
        errorMessage[type] = { status: FAILURE, value: 'IFSC should be in format HDFC0123456' }
      }
      break

    default:
      break
  }
  dispatch({ type: PROFILE_DUCK.UPDATE_BANK_MESSAGES, payload: { updateBankMessages: errorMessage } })
}
